import SubscribeForm from "@/components/feature/SubscribeForm";

const SubscribeSection = () => (
  <section className="bg-background-200/60 paper-grain">
    <div className="mx-auto max-w-shell px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="font-label text-xs tracking-[0.28em] text-primary-600">线索投递</p>
          <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            手里有旧料？告诉档案室
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            不管是一盘卡带、一份节目录像，还是当年报纸上的一小段，只要有大致年份和出处，
            都值得被认真对待。留下邮箱，整理有进展时我们会告诉你结果。
          </p>
          <ul className="mt-6 space-y-3 font-label text-sm text-foreground-700">
            <li className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-base text-secondary-600"></i>
              有出处的线索优先处理
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-base text-secondary-600"></i>
              涉及隐私的内容一律做匿名处理
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-base text-secondary-600"></i>
              核实后仍存疑的，会标注「未获证实」
            </li>
          </ul>
        </div>
        <div className="lg:col-span-8">
          <SubscribeForm />
        </div>
      </div>
    </div>
  </section>
);

export default SubscribeSection;